/* API base URL constant. Swap point for HttpTismsApi. */
export const TISMS_API_URL = 'https://tismsapi.eleave.in/api/v1/';
